<template>
    <span>
        <b-btn @click="modalClick" variant="outline-green" size="sm"><b-icon icon="plus" scale="1.2"></b-icon></b-btn>

        <!-- modal edit postulation -->
        <b-modal
            :id="`modal-create-postulation`"
            centered
            hide-footer
            size="md"
            no-close-on-backdrop
            no-close-on-esc
            header-class="pb-0"
        >
            <!-- modal header -->
            <template #modal-header="">
                <b-container fluid style="border-bottom:1px solid rgba(0, 0, 0, 0.075)" class="pt-1 pb-3">
                    <b-row align-h="between" align-v="center">
                        <b-col cols="auto"><h3 class="text-primary mb-0 text-uppercase">Crear Postulación</h3></b-col>
                        <b-col cols="auto">
                            <b-button size="sm" variant="magenta" @click="modalClose" :disabled="loading">
                                <b-icon icon="x" scale="1.5"/>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-container>
            </template>

            <!-- modal content -->
            <template #default>
                <b-container>
                    <b-row>
                        <b-col>
                            <b-form @submit.prevent="editPostulation">
                                <b-form-row>
                                    <b-col cols="12">
                                        <!-- programSeasonSponsors by programSeason -->
                                        <b-form-group label="Sponsor:" >
                                            <pulse-loader
                                                :loading="sponsorsLoading || loading"
                                                :color="'#5e72e4'"
                                                :margin="'5px'"
                                                :size="10"
                                                class="text-center pt-2 pb-1 pl-2"
                                                style="border-radius:5px; border:1px solid #5e72e4"
                                            />

                                            <b-form-select
                                                v-model="programSeasonSponsor_id"
                                                :options="programSeasonSponsorsOptions"
                                                :state="showInputStatus('fake')"
                                                v-show="!sponsorsLoading && !loading"
                                                @change="searchJobs"
                                            >
                                                <template #first>
                                                    <b-form-select-option value="" class="text-primary" disabled>
                                                        - - Seleccionar un sponsor - -
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>

                                            <b-form-invalid-feedback v-for="(inputError, i) in showInputErrors('fake')" :key="`${i}-up-fake`">{{ inputError }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12">
                                        <!-- programSponsorJobs by programSeasonSponsor -->
                                        <b-form-group label="Oferta laboral:" >
                                            <pulse-loader
                                                :loading="sponsorsLoading || jobsLoading || loading"
                                                :color="'#5e72e4'"
                                                :margin="'5px'"
                                                :size="10"
                                                class="text-center pt-2 pb-1 pl-2"
                                                style="border-radius:5px; border:1px solid #5e72e4"
                                            />

                                            <b-form-select
                                                v-model="programSponsorJob_id"
                                                :options="programSponsorJobsOptions"
                                                :state="showInputStatus('programSponsorJob_id')"
                                                v-show="!sponsorsLoading && !jobsLoading && !loading"
                                            >
                                                <template #first>
                                                    <b-form-select-option value="" disabled>
                                                        - - Selecciona una oferta laboral - -
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>

                                            <b-form-invalid-feedback v-for="(inputError, i) in showInputErrors('programSponsorJob_id')" :key="`${i}-up-programSponsorJob_id`">{{ inputError }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-form-row>

                                <b-form-row>
                                    <b-col>
                                        <b-form-group label="Posición:" >
                                            <pulse-loader
                                                :loading="loading"
                                                :color="'#5e72e4'"
                                                :margin="'5px'"
                                                :size="10"
                                                class="text-center pt-2 pb-1 pl-2"
                                                style="border-radius:5px; border:1px solid #5e72e4"
                                            />

                                            <b-form-select
                                                v-model="subject"
                                                :options="subjectOptions"
                                                :state="showInputStatus('subject')"
                                                v-show="!loading"
                                            >
                                                <template #first>
                                                    <b-form-select-option value="" disabled>
                                                        - - Seleccione una opción - -
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>

                                            <b-form-invalid-feedback v-for="(inputError, i) in showInputErrors('subject')" :key="`${i}-up-subject`">{{ inputError }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-form-row>

                                <b-row align-v="center" align-h="center">
                                    <b-col cols="auto">
                                        <b-button class="text-uppercase" variant="primary" type="submit" size="lg" :disabled="loading"
                                            >Registrar
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col class="mt-5">
                            <b-alert show class="text-center" variant="magenta" v-if="messageError">{{ messageError }}</b-alert>
                        </b-col>
                    </b-row>
                </b-container>
            </template>
        </b-modal>
    </span>
</template>

<script>
import { getProgramSeasonParticipantLite } from '@/api/ProgramSeasonParticipant/ProgramSeasonParticipant'
// ProgramSeason.ProgramSeasonSponsors
import { getProgramSeasonProgramSeasonSponsors } from '@/api/ProgramSeason/ProgramSeasonProgramSeasonSponsor'
// ProgramSeasonSponsor.ProgramSponsorJobs
import { getProgramSeasonSponsorProgramSponsorJobsLite } from '@/api/ProgramSeasonSponsor/ProgramSponsorJob'

import { registerPostulation } from '@/api/Postulation/Postulation';
import swal from 'sweetalert'

export default {
    name: "CreateAttemptComponent",
    props: {
        IdProgramSeasonParticipant: {
            required: true
        }
    },

    data: () => ({
        programSeasonSponsor_id: '',
        programSponsorJob_id: '',
        subject: '',
        //
        sponsorsLoading: false,
        programSeasonSponsorsOptions: [],
        // sponsorIdSelected: '',
        //
        jobsLoading: false,
        programSponsorJobsOptions: [],
        // jobIdSelected: '',
        //
        loading: false,
        inputErrors: {},
        initialInputValues: true,

        subjectOptions: [
            {value: 'Primera opción', text: 'Primera opción'},
            {value: 'Segunda opción', text: 'Segunda opción'},
            {value: 'Tercera opción', text: 'Tercera opción'},
            {value: 'Cuarta opción', text: 'Cuarta opción'},
        ],
        messageError: ''
    }),

    methods: {
        modalClick () {
            this.getData()
            this.$bvModal.show('modal-create-postulation')
        },

        getData () {
            // to get IdProgramSeason
            this.sponsorsLoading = true
            getProgramSeasonParticipantLite(this.IdProgramSeasonParticipant)
                .then(({ data }) => {
                    // to get SPONSORS(programSeasonSponsor) by programSeason
                    getProgramSeasonProgramSeasonSponsors(1, data.data.attributes.programSeason_id)
                        .then(({ data }) => {
                            this.programSeasonSponsorsOptions = data.data.map(el => ({ value: el.attributes.id, text: el.attributes.sponsor_name }))
                            this.programSeasonSponsor_id = this.programSeasonSponsorsOptions[0].value
                            this.getJobsBySponsor(this.programSeasonSponsorsOptions[0].value)
                        })
                        .finally(() => {
                            this.sponsorsLoading = false
                        })
                })
        },

        getJobsBySponsor (pProgramSeasonSponsorId) {
            this.programSponsorJob_id = ''

            //to get JOBS(programSponsorJobs) by SPONSOR(programSeasonSponsor)
            this.jobsLoading = true
            getProgramSeasonSponsorProgramSponsorJobsLite(pProgramSeasonSponsorId)
                .then(({ data }) => {
                    this.programSponsorJobsOptions = data.data.map(el => ({ value: el.attributes.id, text: el.attributes.job_name}))
                })
                .finally(() => {
                    this.jobsLoading = false
                })
        },

        searchJobs (e) {
            this.getJobsBySponsor(e)
        },

        modalClose () {
            this.$bvModal.hide('modal-create-postulation')
            this.clearInputsAndStates()
        },


        editPostulation() {
            this.loading = true
            this.initialInputValues = false
            this.inputErrors = {}

            let PostulationForm = new FormData()
            PostulationForm.append('programSeasonParticipant_id', this.IdProgramSeasonParticipant)
            PostulationForm.append('programSponsorJob_id', this.programSponsorJob_id)
            PostulationForm.append('subject', this.subject)

            registerPostulation(PostulationForm)
                .then(() => {
                    swal('Actualización correcta!', '', 'success')
                        .then(val => {
                            switch(val) {
                                case true:
                                case null:
                                    this.$emit('created')
                                    this.modalClose()
                                    break;
                                default:
                                    console.log('create-postulation-subject-breck');
                                    break;
                            }
                        })
                })
                .catch(err => {
                    if (err.response.status == 422) {
                        this.inputErrors = err.response.data.errors
                    }
                    if (err.response.status == 404) {
                        this.messageError = err.response.data.message
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        showInputErrors (pInput) {
            if (Object.keys(this.inputErrors).includes(pInput)) return this.inputErrors[pInput]
            else return []
        },

        showInputStatus (pInput) {
            if (this.initialInputValues) return null 
            else if (Object.keys(this.inputErrors).includes(pInput)) return false
            else return true
        },

        clearInputsAndStates() {
            this.inputErrors = {}
            this.initialInputValues = true
            this.messageError = ''
        },
    }
}
</script>